import { useState } from 'react';
import { Image } from 'antd';
import { useIntl } from 'react-intl';
import { ProductImageProps } from 'types/ProductData';
import { Button, Icon, Modal } from 'ui';
import { FallbackImage } from 'ui/UploadImage/fallBack/FallBackImage';

const extractYouTubeId = (url: string): string | null =>
  url.match(
    /(?:youtube\.com.*(?:\/|v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  )?.[1] ?? null;

interface FarmGalleryProps {
  images?: ProductImageProps[];
  youtubeLink?: string;
}

const FarmGallery = ({ images, youtubeLink }: FarmGalleryProps) => {
  const intl = useIntl();
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const videoId = youtubeLink ? extractYouTubeId(youtubeLink) : null;
  const videoLabel = intl.formatMessage({ id: 'farm_view.video' });

  return (
    <div className={'farm-gallery'}>
      {videoId && (
        <Button
          className={'farm-gallery-item farm-gallery-video'}
          title={videoLabel}
          label={
            <>
              <img
                src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                alt={videoLabel}
              />
              <span className={'farm-gallery-play'}>
                <Icon name={'play'} type={'any'} />
              </span>
            </>
          }
          onClick={() => setIsVideoOpen(true)}
        />
      )}
      <Image.PreviewGroup>
        {images?.map((image, index) => (
          <FallbackImage
            key={`${image.url_original}-${index}`}
            className={'farm-gallery-item'}
            src={image.url_original}
            type={'FarmGalery'}
            preview={true}
            alt={''}
          />
        ))}
      </Image.PreviewGroup>

      {videoId && (
        <Modal
          open={isVideoOpen}
          onCancel={() => setIsVideoOpen(false)}
          footer={null}
          centered
          width={860}
          destroyOnClose
          className={'farm-video-modal'}
        >
          <div className={'farm-video-frame'}>
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
              title={videoLabel}
              allow={
                'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              }
              allowFullScreen
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default FarmGallery;
